import { fromJS } from 'immutable';
import * as actions from '../../actions/equityFinder/master';
import { fetchingState, defaultPageSize } from '../../constants';

const initialStats = {
  masterCompModal: {
    propertyList: {
      pageSize: defaultPageSize,
      sortModel: [],
    },
    searchRule: {},
    selectedProperties: [],
  },
  masterList: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.MASTER_COMP_PROPERTY_SEARCH_START:
      return state.setIn(
        ['masterCompModal', 'propertyList', 'state'],
        fetchingState.FETCHING,
      );
    case actions.MASTER_COMP_PROPERTY_SEARCH_SUCCESS:
      let newState = state.setIn(
        ['masterCompModal', 'propertyList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['masterCompModal', 'propertyList', 'totalCount'],
        action?.data?.totalProperty ? action.data.totalProperty.propCount : 0,
      );
      return newState.setIn(
        ['masterCompModal', 'propertyList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );

    case actions.MASTER_COMP_PROPERTY_SEARCH_ERROR:
      return state.setIn(
        ['masterCompModal', 'propertyList', 'state'],
        fetchingState.ERROR,
      );

    case actions.MASTER_FETCH_START:
      return state.setIn(['masterList', 'state'], fetchingState.FETCHING);
    case actions.MASTER_FETCH_SUCCESS:
      newState = state.setIn(['masterList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['masterList', 'data'],
        fromJS(action?.data?.results ? action.data.results : []),
      );
    case actions.MASTER_FETCH_ERROR:
      return state.setIn(['masterList', 'state'], fetchingState.ERROR);

    case actions.MASTER_REMOVE_SUCCESS:
      let newMasterList = state.getIn(['masterList', 'data']).toJS();
      newMasterList = newMasterList.filter(
        (master) => master.id !== action.masterId,
      );
      return state.setIn(['masterList', 'data'], fromJS(newMasterList));

    case actions.MASTER_ADD_SUCCESS:
      return state.setIn(
        ['masterList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );

    case actions.MASTER_COMP_PROPERTY_CHANGE_CURRENT_PAGE:
      return state.setIn(
        ['masterCompModal', 'propertyList', 'currentPage'],
        action.data,
      );
    case actions.MASTER_COMP_PROPERTY_CHANGE_PAGE_SIZE:
      return state.setIn(
        ['masterCompModal', 'propertyList', 'pageSize'],
        action.data,
      );
    case actions.MASTER_COMP_PROPERTY_CHANGE_SORT_MODEL:
      return state.setIn(
        ['masterCompModal', 'propertyList', 'sortModel'],
        fromJS(action.data),
      );

    case actions.MASTER_COMP_PROPERTY_SET_SEARCH_RULE:
      return state.setIn(
        ['masterCompModal', 'searchRule', action.data.ruleName],
        action.data.ruleValue,
      );
    case actions.MASTER_COMP_PROPERTY_REMOVE_SEARCH_RULE:
      return state.setIn(
        ['masterCompModal', 'searchRule', action.data.ruleName],
        undefined,
      );
    case actions.MASTER_COMP_PROPERTY_REMOVE_ALL_SEARCH_RULE:
      return state.setIn(['masterCompModal', 'searchRule'], fromJS({}));

    case actions.MASTER_COMP_SELECT_PROPERTY:
      return state.setIn(
        ['masterCompModal', 'selectedProperties'],
        action.data,
      );

    default:
      return state;
  }
};
